module.exports = __webpack_public_path__ + "img/kv.b07dca26.png";